import dayjs from 'dayjs'
import { Grid } from '@mui/material'
import { SERVICES_FIELDS } from '../../../providers/localization/constant'
import { isBeforeDate, isAfterDate } from '../../../utils/validators'
import { DateTimeInput, required } from 'react-admin'

type PeriodDateInputsProps = {
  isApproved?: boolean
}

export const PeriodDateInputs: React.FC<PeriodDateInputsProps> = ({ isApproved = false }) => {
  const defaultStartDate = dayjs()
  const defaultEndDate = defaultStartDate.add(1, 'day')

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <DateTimeInput
          source='start_date'
          label={`${SERVICES_FIELDS}.start_date`}
          disabled={isApproved}
          fullWidth
          defaultValue={defaultStartDate}
          validate={[
            required(),
            isBeforeDate('end_date', 'The start date must be in before the end date.'),
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DateTimeInput
          source='end_date'
          disabled={isApproved}
          label={`${SERVICES_FIELDS}.end_date`}
          fullWidth
          defaultValue={defaultEndDate}
          validate={[
            required(),
            isAfterDate('start_date', 'The end date must be in after the start date.'),
          ]}
        />
      </Grid>
    </Grid>
  )
}
